'use client'

import styled from 'styled-components'
import {FreeMode, Navigation} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/swiper-bundle.css'

import {Routes} from '@/src/config/routes'
import {mediaSizes} from '@/src/config/theme'

import type {Brand} from '@/src/entities/brand/type'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Image} from '@/src/shared/ui/image'

import * as UI from './slider.styled'

interface IProps {
  brands: Brand[]
}

const StyledSwiper = styled(Swiper)`
  --swiper-navigation-color: 'gray';

  & .swiper-wrapper {
    align-items: center;

    .swiper-slide {
      img {
        max-width: min(30vw, 145px);
      }
    }
  }

  &.swiper {
    .swiper-button-prev {
      left: 0;
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after,
    .swiper-button-next:after,
    .swiper-button-prev:after {
      font-size: 1.375rem;
      font-weight: 450;
    }
  }
`

export const BrandSlider = ({brands}: IProps) => {
  return (
    <StyledSwiper
      slidesPerView={2}
      freeMode
      navigation
      modules={[FreeMode, Navigation]}
      breakpoints={{
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        [mediaSizes.md]: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        [mediaSizes.lg]: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      }}>
      {brands.map(brand => (
        <SwiperSlide key={brand.id}>
          <UI.Wrapper>
            <UI.Link href={Routes.brands.detail(brand.name)} asChild>
              <Image
                src={(brand.image && brand.image.type == 'image' && brand.image.src) || noPhotoPic}
                width={195}
                height={195}
                alt={brand.name}
              />
            </UI.Link>
          </UI.Wrapper>
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}
